import { Component } from '@angular/core';

@Component({
	selector: 'g-loading-indicator',
	templateUrl: './loading-indicator.component.html',
	styleUrls: ['./loading-indicator.component.scss'],
	standalone: false,
})
export class LoadingIndicatorComponent {
	placeholders = Array.from({ length: 6 }).fill(true);
}
